import { Name } from "../Name";
import { Number } from "../Number";
export var Restriction;
(function (Restriction) {
    function convert(restriction) {
        const { verify, condition, allowed } = getVerifier(...restriction);
        return allowed ? [verify, condition, Name.fromString(allowed)] : [verify, condition];
    }
    Restriction.convert = convert;
    function getVerifier(...[property, ...argument]) {
        const argument0 = argument[0];
        const conditions = {
            value: argument0 instanceof RegExp
                ? {
                    condition: `value: ${argument0.toString()}`,
                    verify: (value) => argument0.test(value),
                }
                : ((allowed) => ({
                    allowed,
                    condition: `value: ${allowed.length == 1 ? `'${allowed[0]}'` : `[${allowed.map(a => `'${a}'`).join(", ")}]`}`,
                    verify: (value) => allowed.some(a => a == value),
                }))((Array.isArray(argument0) ? argument0 : argument)),
            length: ((verifier) => ({
                verify: (value) => verifier.verify(value.length),
                condition: "length." + verifier.condition,
            }))(Number.Restriction.getVerifier(...argument)),
        };
        return conditions[property];
    }
    Restriction.getVerifier = getVerifier;
})(Restriction || (Restriction = {}));
//# sourceMappingURL=Restriction.js.map